module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10473/images/animated-images/email_open.webm"